import { Capacitor } from "@capacitor/core";
import type {
  TrackEventInput,
  ResolvedTrackEventInput,
  PlatformValue,
} from "./types";
import { trackEvent as trackEventWeb } from "./web";
import { trackEvent as trackEventApp } from "./app";

function isNativeApp(): boolean {
  try {
    if (
      Capacitor &&
      typeof Capacitor.isNativePlatform === "function" &&
      Capacitor.isNativePlatform()
    ) {
      return true;
    }
  } catch {}
  const forced = process.env.REACT_APP_RUNTIME;
  if (forced === "app") return true;
  if (forced === "web") return false;

  // Use Capacitor's built-in platform detection
  const isNative = Capacitor.isNativePlatform();
  return isNative;
}

function resolvePlatformValue(value: PlatformValue, native: boolean): string {
  if (typeof value === "string") return value;
  return native ? value.app ?? value.web ?? "" : value.web ?? value.app ?? "";
}

export async function trackEvent(input: TrackEventInput): Promise<void> {
  const native = isNativeApp();

  const resolved: ResolvedTrackEventInput = {
    ...input,
    event_name: resolvePlatformValue(input.event_name, native),
    event_category: resolvePlatformValue(input.event_category, native),
  };

  console.log("[Events] trackEvent resolved:", resolved, {
    platform: native ? "app" : "web",
  });

  if (native) {
    console.log("[Events] trackEvent dispatch: app");
    return trackEventApp(resolved);
  }
  console.log("[Events] trackEvent dispatch: web");
  return trackEventWeb(resolved);
}

export const runtimePlatform: "web" | "app" = isNativeApp() ? "app" : "web";
